import { Island } from '../island.class';
import { IslandType } from '../enums';

/**
 * Updates the island's type based on height for resizable types.
 *
 * Fixed-size types (no height checking, type unchanged):
 * - Corner, Pizza, Asado
 *
 * Resizable types (height-based type update):
 * - height >= 36.75" → Bar
 * - height >= 27.5" → Grill
 * - height < 27.5" → Smoker
 *
 * @param island - Island to update type for
 */
export const determineIslandTypeCfn = (island: Island): void => {
	// Fixed-size types don't need updating
	if (island.type === IslandType.Corner || island.type === IslandType.Pizza || island.type === IslandType.Asado) {
		return;
	}

	// Update type based on height for resizable types
	if (island.size.height >= 36.75) {
		island.type = IslandType.Bar;
	} else if (island.size.height >= 27.5) {
		island.type = IslandType.Grill;
	} else {
		island.type = IslandType.Smoker;
	}
};
